<template>
  <ul class="pagination">
    <li v-if="active > 1" class="page-item active hide-in-print">
      <button @click.prevent="$emit('changed', active - 1)" class="btn btn-brand1">
        <span class="icon icon-navigation_pfeil_links" aria-hidden="true"></span>
        <span class="sr-only">{{ $t('common.pagingPrev') }}</span>
      </button>
    </li>
    <li v-for="(page, index) in max" :key="index" v-bind:class="{ 'active': active === page }" class="page-item">
      <button @click.prevent="$emit('changed', page)" class="btn" :class="active === page ? 'btn-brand1' : 'btn-outline-brand1'">{{ page }}</button>
    </li>
    <li v-if="active < max" class="page-item hide-in-print">
      <button @click.prevent="$emit('changed', active + 1)" class="btn btn-outline-brand1">
        <span class="icon icon-navigation_pfeil_rechts" aria-hidden="true"></span>
        <span class="sr-only">{{ $t('common.pagingNext') }}</span>
      </button>
    </li>
  </ul>
</template>

<script lang="ts">
import { defineComponent } from 'vue'

export default defineComponent({
  name: 'ResultPaging',
  props: {
    active: {
      type: Number,
      required: true
    },
    max: {
      type: Number,
      required: true
    }
  },
  methods: {
  }
});
</script>
<style scoped>
.pagination{
  display: flex;
  list-style: none;
}

.pagination li{
  margin: 0 .3125rem;
  padding-left: 0;
}

.pagination li button{
  min-width: 2.4375rem;
}

@media print{
  .btn-brand1{
    -webkit-print-color-adjust: exact;
  }
}
</style>
